import { urlApi } from "./urls";

function numberWithCommas(x) {
  if (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",-";
  }
  return "-";
}

function numberWithAbbr(x) {
  if (x > 1000000) {
    return (x / 1000000).toFixed(0).toString() + "M";
  }
  return (x / 1000).toFixed(0).toString() + "K";
}

function changeDateFormat(x) {
  if (x) {
    const date = new Date(x);
    // Default locale and time zone from the browser
    const browserLanguage = navigator.language;
    const formattedDate = date.toLocaleString(browserLanguage, {
      hourCycle: "h24",
      weekday: "long",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    return formattedDate;
  }
  return "-";
}

function changeDateFilterFormat(date) {
  // Default locale and time zone from the browser
  const browserLanguage = navigator.language;
  const formattedDate = date.toLocaleString(browserLanguage, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return formattedDate;
}

const handleOnClickLogout = (event, setLoading, token, navigate) => {
  event.preventDefault();
  setLoading(true);
  try {
    if (true) {
      fetch(urlApi + "/v1/auth/logout", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => {
          response.json();
        })
        .then((data) => {
          try {
            localStorage.removeItem("user_info");
          } catch (error) {
            console.log(error);
          }
          let mission = JSON.parse(localStorage.getItem("mission"));
          if (mission) {
            localStorage.removeItem("mission");
          }
          setLoading(false);
          navigate("/login");
        })
        .catch((error) => {
          navigate("/login");
        });
    }
  } catch {
    setLoading(false);
    navigate("/login");
  }
};

const createDetail = (data) => {
  if ((data.machine.value !== "-") & (data.zone.value !== "-")) {
    let vcpu = specMachine[data.machine.value].cpu;
    let ram = specMachine[data.machine.value].ram;
    let region = mapZonetoZoneRegion[data.zone.value];
    let time = data.time.value;
    return [vcpu, ram, region, time];
  }
  return ["-", "-", "-", data.time.value];
};

function resizeImage(img, aspect = 1) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No 2d context");
  }

  canvas.width = 300 * aspect;
  canvas.height = 300;

  // draw source image into the off-screen canvas:
  ctx.drawImage(img, 0, 0, 300 * aspect, 300);

  // As Base64 string
  return canvas.toDataURL("image/png");
}

function canvasPreview(image, crop, aspect = 1, isResize = true) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No 2d context");
  }

  // devicePixelRatio slightly increases sharpness on retina devices
  // at the expense of slightly slower render times and needing to
  // size the image back down if you want to download/upload and be
  // true to the images natural size.
  const pixelRatio = 1;
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
  canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.save();

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  // Move the crop origin to the canvas origin (0,0)
  ctx.translate(-cropX, -cropY);
  ctx.drawImage(
    image,
    0,
    0,
    image?.naturalWidth,
    image?.naturalHeight,
    0,
    0,
    image?.naturalWidth,
    image?.naturalHeight,
  );

  ctx.restore();

  // As Base64 string
  if (isResize) {
    return resizeImage(canvas, aspect);
  }
  return canvas.toDataURL("image/png");
}

const formatTime = (second) => {
  let minutes = Math.floor(second / 60);
  let seconds = Math.floor(second - minutes * 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return minutes + ":" + seconds;
};

const diffTimeMinutes = (date1, date2) => {
  var diff = Math.abs(date1 - date2);
  return Math.ceil(diff / 1000 / 60);
};

const diffTimeSeconds = (date1, date2) => {
  var diff = Math.abs(date1 - date2);
  return Math.ceil(diff / 1000);
};

const checkSizeData = (size) => {
  if (size / 1000000000 > 1) {
    return "GB";
  } else if (size / 1000000 > 1) {
    return "MB";
  } else if (size / 1000 > 1) {
    return "KB";
  }
  return "B";
};

const transformSizeData = (size) => {
  if (size / 1000000000 > 1) {
    return (size / 1000000000).toFixed(1);
  } else if (size / 1000000 > 1) {
    return (size / 1000000).toFixed(1);
  } else if (size / 1000 > 1) {
    return (size / 1000).toFixed(1);
  }
  return size.toFixed(1);
};

const replaceUrl = (inputValue, baseUrl, placeholder) => {
  if (baseUrl && placeholder) {
    if (baseUrl.includes("username")) {
      return baseUrl.replace("username", inputValue);
    }
    if (baseUrl.includes("phone")) {
      return baseUrl.replace("phone", inputValue);
    }
  }
  return inputValue;
};

function base64ToBytes(base64) {
  const binaryString = atob(base64); // Decodes Base64 to a binary string
  const length = binaryString.length;
  const bytes = new Uint8Array(length); // Creates a Uint8Array of the correct length

  for (let i = 0; i < length; i++) {
    bytes[i] = binaryString.charCodeAt(i); // Populates the Uint8Array with byte values
  }
  return bytes;
}

function getLinkedInUsernameRegex(url) {
  const regex = /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/]+)/;
  const match = url.match(regex);
  if (match && match[1]) {
    return match[1];
  }
  return url;
}

function getYouTubeUsernameFromUrl(url) {
  // Regex for /user/username and /c/customurl formats
  const usernameRegex = /(?:youtube\.com\/(?:user|c)\/|youtu\.be\/)([^/?&#]+)/i;
  const match = url.match(usernameRegex);

  if (match && match[1]) {
    return match[1];
  }

  // Regex for older /channel/channelid format (where the channel ID might be mistaken for a username)
  const channelIdRegex = /youtube\.com\/channel\/([^/?&#]+)/i;
  const channelIdMatch = url.match(channelIdRegex);

  if (channelIdMatch && channelIdMatch[1]) {
    // This is likely a channel ID, not a traditional username.
    // You might want to handle this differently or return it as "channelId"
    return channelIdMatch[1];
  }

  const channelUsernameRegex = /youtube\.com\/@([^/?&#]+)/i;
  const channelUsernameMatch = url.match(channelUsernameRegex);

  if (channelUsernameMatch && channelUsernameMatch[1]) {
    // This is likely a channel ID, not a traditional username.
    // You might want to handle this differently or return it as "channelId"
    return channelUsernameMatch[1];
  }

  return url;
}

function getXUsernameFromUrl(url) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:x\.com|twitter\.com)\/([a-zA-Z0-9_]+)/;
  const match = url.match(regex);

  if (match && match[1]) {
    return match[1]; // The username is in the first capturing group
  } else {
    return url; // No username found or URL is not an X profile URL
  }
}

const setDateForFilter = (x) => {
  const offset = x.getTimezoneOffset();
  let yourDate = new Date(x.getTime() - offset * 60 * 1000);
  return yourDate.toISOString().split("T")[0];
};

const generateCardSocial = (phones, emails, address) => {
  let cardSocial = [];
  let filteredPhone = phones.filter((val, ind) => val.phone);
  cardSocial.push(
    ...filteredPhone.map((val, ind) => {
      return {
        chosen_value: "personal",
        display_text: val.label,
        input_value: val.phone,
        lookup_id: "LKP3cb4c0867b0f4a479b35b5bea1328fc3",
      };
    }),
  );
  let filteredEmail = emails.filter((val, ind) => val.email);
  cardSocial.push(
    ...filteredEmail.map((val, ind) => {
      return {
        chosen_value: "personal",
        display_text: val.label,
        input_value: val.email,
        lookup_id: "LKP8d00ffb749ce4cb4a26236888b7614e2",
      };
    }),
  );
  if (address) {
    let filteredAddress = [
      {
        chosen_value: "personal",
        display_text: "personal",
        input_value: address,
        lookup_id: "LKPe0c77ceb40aa4054bf16a9221752acd8",
      },
    ];
    cardSocial.push(...filteredAddress);
  }
  return cardSocial;
};

const checkIsMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

export {
  createDetail,
  numberWithCommas,
  canvasPreview,
  formatTime,
  handleOnClickLogout,
  diffTimeMinutes,
  diffTimeSeconds,
  checkSizeData,
  transformSizeData,
  base64ToBytes,
  replaceUrl,
  numberWithAbbr,
  changeDateFormat,
  changeDateFilterFormat,
  getLinkedInUsernameRegex,
  getYouTubeUsernameFromUrl,
  getXUsernameFromUrl,
  setDateForFilter,
  generateCardSocial,
  checkIsMobile,
};
